// Use RTK queries instead of createAsyncThunk for new APIs, createAsyncThunk is used here due to
// the non-generic nature of the SignIn controller.
import { createAsyncThunk } from "@reduxjs/toolkit";
import ActionHelper from "../../../Common/Actions/ActionHelper";
import FrontEndApi from '../../../Common/Globals/Scripts/FrontEndApi';
import { authenticationFailed } from './SignInSlice';

export type SignInWithPasswordArgs = {
    username: string;
    password: string;
    returnUrl: string | undefined;
};

export const signInWithPassword = createAsyncThunk(
    'signIn/signInWithPassword',
    async (args: SignInWithPasswordArgs, thunkApi) => {
        const { username, password, returnUrl } = args;

        try {
            await ActionHelper.executeRequest(async () => await FrontEndApi.signInWithPassword(username, password));
            return { data: returnUrl };
        } catch (error) {
            thunkApi.dispatch(authenticationFailed());
            return thunkApi.rejectWithValue(error);
        }
    }
);

export const getUserNameWithSessionKey = createAsyncThunk(
    'signIn/getUserNameWithSessionKey',
    // This is the signature of a thunk API reducer and there are no alternative overloads.
    async (sessionKey: string, thunkApi) => {
        const response = await ActionHelper.executeRequest(async () => {
            const result = await FrontEndApi.getUserNameWithSessionKey(sessionKey) as Response;
            return result.json();
        });
        return { data: response as string };
    }
);
